import { useState, useEffect, useRef } from "react";
import React from "react";
import {
  FilterFichaFinanceiraDto,
  GetFinancialRecordDto,
  UpdateStatusImpressaoDto,
} from "../../../../shared/dtos/FichaFinanceira.dto";
import TabelaFiltroModal from "../../../../components/TabelaFiltroModal/TabelaFiltroModal";
import DetailsModal from "../../../../components/DetalheModal/detalhe_modal";
import CadastroParcela from "../../../../components/ModalCadastroParcela/ModalCadastroParcela";
import InputComponent from "../../../../components/Input/input";
import { Label } from "../../../../components/Label/styles";
import { ContainerButtons, ContainerFilter } from "../../style";
import { IoCloseSharp, IoFilter, IoSearchSharp } from "react-icons/io5";
import { Colors } from "../../../../shared/colors/colors";
import Button from "../../../../components/Button/button";
import { MdOutlineViewColumn } from "react-icons/md";
import { IoIosAddCircleOutline, IoMdClose } from "react-icons/io";
import { Dropdown, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { SlOptionsVertical } from "react-icons/sl";
import {
  ButtonAction,
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/Table/styles";
import {
  LoadingGif,
  LoadingOverlay,
} from "../../../../shared/styles/global.styles";
import loadSCGif from "../../../../assets/load_SC.gif";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../../components/Dropdowns/styles";
import Swal from "sweetalert2";
import ManualClearanceModal from "../../../../components/ManualClearanceModal/manualClearanceModal";
import dadosFinanceirosService from "../../../../services/DadosFinanceirosService";
import CancelInstallmentsModal from "../../../../components/CancelInstallmentsModal/cancelInstallments";
import FichaFinanceiraService from "../../../../services/FichaFinanceiraService";
import {
  formatarData,
  formatDateToBR,
} from "../../../../utils/dateUtils/dateUtils";
import Pagination from "../../../../components/Pagination/pagination";
import {
  LoadingContainer,
  MainContainer,
  TableContainer,
  FichaFinanceiraMenuTable,
  FichaFinanceiraMenuItem,
  FichaFinanceiraMenuDivider,
  AppliedFilters,
  FiltersContainer,
  FilterItem,
  FilterKey,
  FilterValue,
  FilterRemoveButton,
} from "./styles";
import QrCodeModal from "../../../../components/QRCodeModal/qrCode_modal";
import {
  StatusImpressaoEnum,
  StatusParcelaEnum,
  StatusRemessaEnum,
} from "../../../../shared/enum/fichaFinanceira.enum";
import ReciboDoacaoPDF from "../../../../components/Recibo_Doação/recibo_doacao";
import { pdf } from "@react-pdf/renderer";
import { ReciboService } from "../../../../services/ReciboService";
import caixaService from "../../../../services/CaixaService";
import { formatCurrency } from "../../../../utils/formatCurrency/formatCurrency";

export interface FichaFinanceiraResponse {
  statusParcela: number;
  sequencialParcela: number;
  nossoNumero: number;
  tipoCobranca: string;
  valorParcela: number;
  dataVencimento: string; // Mantenha como string se preferir
  valorAjuste: string;
  valorPago: number;
  valorTarifa: string;
  dataPagamento: string | null; // Pode ser uma string ou null
  statusImpressao: StatusImpressaoEnum;
  statusRemessa: string;
}

interface Props {
  idContribuinte: number;
  cancelFutureInstallmentsIds: number[];
  setCancelFutureInstallmentsIds: React.Dispatch<
    React.SetStateAction<number[]>
  >;
  editOnly: boolean;
}

const FichaFinanceiraPage: React.FC<Props> = ({
  idContribuinte,
  cancelFutureInstallmentsIds,
  setCancelFutureInstallmentsIds,
  editOnly,
}) => {
  const [financialRecords, setFinancialRecords] = useState<
    GetFinancialRecordDto[]
  >([]);
  const [filteredRecords, setFilteredRecords] = useState<
    GetFinancialRecordDto[]
  >([]);
  const [searchValue, setSearchValue] = useState("");
  const [showFiltroModal, setShowFiltroModal] = useState(false);
  // const [showColumnSelector, setShowColumnSelector] = useState(false);
  // const columnButtonRef = React.useRef<HTMLButtonElement | null>(null);
  // const [modalPosition, setModalPosition] = useState<{
  //   top: number;
  //   left: number;
  // }>({ top: 0, left: 0 });
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedRecord, setSelectedRecord] =
    useState<GetFinancialRecordDto | null>(null);
  const [appliedFilters, setAppliedFilters] =
    useState<FilterFichaFinanceiraDto>({});
  const [showCadastroParcela, setShowCadastroParcela] = useState(false);
  // const [isRequest, setIsRequest] = useState<boolean>(false);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectedInstallments, setSelectedInstallments] = useState<
    GetFinancialRecordDto[]
  >([]);

  // Função utilitária para verificar se todas as selecionadas estão pagas
  const todasParcelasPagas =
    selectedInstallments.length > 0 &&
    selectedInstallments.every(
      (parcela) => parcela.statusParcela === StatusParcelaEnum.PAGA
    );
  const [selectedSingleInstallment, setSelectedSingleInstallment] =
    useState<GetFinancialRecordDto | null>(null);
  const [showManualClearanceModal, setShowManualClearanceModal] =
    useState<boolean>(false);
  const [showCancelInstallmentsModal, setShowCancelInstallmentsModal] =
    useState<boolean>(false);
  const [dadosFinanceirosAtivo, setDadosFinanceirosAtivo] = useState<any>(null);
  const [isSearch, setIsSearch] = useState(false);
  const [isRequest, setIsRequest] = useState<boolean>(false);

  const defaultColumns = [
    "Parcela",
    "Nosso numero",
    "Tipo cobranca",
    "Valor parcela",
    "Vencimento",
  ];

  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(
        "fichaFinanceiraVisibleColumns"
      );
      if (!savedColumns) return defaultColumns;

      const parsedColumns = JSON.parse(savedColumns);
      // Garante que as colunas padrão estejam sempre presentes
      return Array.from(new Set([...defaultColumns, ...parsedColumns]));
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const [fichaFinanceiraVisibleColumns, setVisibleColumns] =
    useState<string[]>(loadVisibleColumns);
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>([]); // Estado temporário
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalParcelas, setTotalParcelas] = useState<number>(0);
  const itemsPerPage = 12;
  const totalPages = Math.ceil(totalParcelas / itemsPerPage);
  const [shouldRefreshData, setShouldRefreshData] = useState(false);
  const [showModalQRCode, setShowModalQRCode] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [selectAllByPage, setSelectAllByPage] = useState<number[]>([]);
  const [selectedByPage, setSelectedByPage] = useState<number[]>([]);
  const handleReactivateClearance = async () => {
    try {
      // Confirma a reativação
      const result = await Swal.fire({
        title: "Confirmação",
        text: `Deseja realmente reativar ${
          selectedInstallments.length
        } parcela${selectedInstallments.length > 1 ? "s" : ""}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim, reativar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
      });

      if (result.isConfirmed) {
        // Mostra loading
        Swal.fire({
          title: "Carregando",
          text: "Reativando parcelas...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Chama o serviço para reativar as parcelas (enviando apenas os IDs)
        await dadosFinanceirosService.reativarParcelas(
          selectedInstallments.map((id) => Number(id.id))
        );

        // Atualiza a lista de parcelas
        await getDataByFilter(appliedFilters);

        // Limpa a seleção
        setSelectedInstallments([]);
        setSelectAllByPage([]);

        // Mostra mensagem de sucesso
        Swal.fire({
          title: "Sucesso!",
          text: "Parcelas reativadas com sucesso",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao reativar parcelas:", error);
      Swal.fire({
        title: "Erro",
        text: "Não foi possível reativar as parcelas. Tente novamente.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const handleParcelSubmit = async (parcelas: any[], idContrib: number) => {
    try {
      await getDataByFilter(appliedFilters);
      setShowCadastroParcela(false);
      // if (onFlowComplete) {
      //   onFlowComplete();
      // } else {

      // }
    } catch (error) {
      console.error("Erro ao cadastrar parcelas:", error);
      Swal.fire({
        title: "Erro",
        text: "Erro ao cadastrar parcelas. Tente novamente.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value;
    setSearchValue(searchValue);
    if (searchValue === "") {
      handleClearSearchInput();
    } else {
      const newFilter = { ...appliedFilters, search: searchValue };
      setAppliedFilters(newFilter);
    }
  };

  const handleUpdate = async (
    ids: number[],
    statusImpressao: StatusImpressaoEnum
  ) => {
    try {
      const result = await Swal.fire({
        title: "Trocar status da impressão",
        text: "Selecione uma opção",
        icon: "question",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        input: "select",
        inputOptions: {
          [StatusImpressaoEnum.A_IMPRIMIR]: "A Imprimir",
          [StatusImpressaoEnum.IMPRESSO]: "Impresso",
          [StatusImpressaoEnum.NAO_IMPRIMIR]: "Não Imprimir",
          [StatusImpressaoEnum.PENDENTE]: "Pendente",
        },
        inputValue: statusImpressao, // Define o status selecionado como padrão
        // inputValidator: (value) => {
        //   if (value === statusImpressao) {
        //     return "Selecione uma opção diferente da atual";
        //   }
        // },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Carregando",
          text: "Atualizando status da impressão...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        await handleUpdateStatusImpressao(ids, result.value);

        await getDataByFilter(appliedFilters);

        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Status da impressão atualizado com sucesso!",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao trocar status da impressão:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao trocar status da impressão",
        allowOutsideClick: false,
      });
    }
  };

  const handleUpdateRemessa = async (
    ids: number[],
    statusRemessaAtual: string
  ) => {
    try {
      const result = await Swal.fire({
        title: "Trocar status da remessa",
        text: "Selecione uma opção",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        input: "select",
        inputOptions: {
          [StatusRemessaEnum.ENVIAR]: "Enviar",
          [StatusRemessaEnum.NAO_ENVIAR]: "Não enviar",
          [StatusRemessaEnum.ENVIADA]: "Enviada",
        },
        inputValue: statusRemessaAtual, // Define o status selecionado como padrão
        // inputValidator: (value) => {
        //   if (value === statusRemessaAtual) {
        //     return "Selecione uma opção diferente da atual";
        //   }
        // },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Carregando",
          text: "Atualizando status remessa...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await FichaFinanceiraService.updateStatusRemessaMany({
          ids,
          status: result.value,
        });

        await getDataByFilter(appliedFilters);

        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Status da remessa atualizado com sucesso!",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao trocar status da remessa:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao trocar status da remessa",
        allowOutsideClick: false,
      });
    }
  };

  const formatFilterName = (filterName: string) => {
    return filterName
      .replace(/([A-Z])/g, " $1") // Insere espaço antes de letras maiúsculas
      .replace(/^./, (str) => str.toUpperCase()) // Capitaliza a primeira letra
      .trim(); // Remove espaços no início e no final
  };

  // Função para alternar colunas no estado temporário
  const handleColumnToggle = (column: string) => {
    setTempVisibleColumns((prev: string[]) => {
      // Se a coluna é padrão, não permite desmarcar
      if (defaultColumns.includes(column) && prev.includes(column)) {
        return prev;
      }

      // Toggle normal para colunas não padrão
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  // Função para aplicar as mudanças
  const handleApplyColumns = () => {
    setVisibleColumns(tempVisibleColumns); // Atualiza as colunas visíveis
    sessionStorage.setItem(
      "fichaFinanceiraVisibleColumns",
      JSON.stringify(tempVisibleColumns)
    ); // Salva no sessionStorage
    setIsOpenMenuCollumn(false); // Fecha o dropdown
  };

  // const toggleColumnSelector = () => {
  //   if (buttonRef.current) {
  //     const buttonRect = buttonRef.current.getBoundingClientRect();
  //     setModalPosition({
  //       top: buttonRect.bottom + window.scrollY,
  //       left: buttonRect.left + window.scrollX,
  //     });
  //   }
  //   setIsOpenMenuCollumn((prev) => !prev);
  // };

  const applyFilters = async (filters: FilterFichaFinanceiraDto) => {
    try {
      // Converte os filtros para o formato esperado pela API
      const params = Object.entries(filters).reduce((acc, [key, value]) => {
        // Ignora valores vazios
        if (!value || value.toString().trim() === "") {
          return acc;
        }

        if (key === "statusParcela") {
          // Converte para o formato correto do enum no backend
          acc[key] =
            value.toString().charAt(0).toUpperCase() +
            value.toString().slice(1).toLowerCase();
        } else if (key === "dataPagamento") {
          // Preserva a data exata sem ajustes de timezone
          const dateStr = value.toString();
          acc[key] = dateStr.includes("T") ? dateStr : `${dateStr}`;
        } else {
          acc[key] = value;
        }

        return acc;
      }, {} as Record<string, any>);

      const newParams = { ...appliedFilters, ...params };
      setAppliedFilters(newParams);

      getDataByFilter(newParams);
    } catch (error) {
      console.error("Erro ao aplicar filtros:", error);
      // Reseta os filtros em caso de erro
      setFilteredRecords(financialRecords);

      Swal.fire({
        title: "Erro",
        text: "Não foi possível aplicar os filtros. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const getDataByFilter = async (filter: FilterFichaFinanceiraDto) => {
    setIsRequest(true);
    if (filter.search) {
      setIsSearch(true);
    }
    // Chama a API com os filtros
    const { fichas, total } =
      await FichaFinanceiraService.getByContribuinteAndFilter(
        idContribuinte,
        filter,
        currentPage,
        itemsPerPage
      );

    if (fichas && Array.isArray(fichas) && fichas.length > 0) {
      setFilteredRecords(fichas);
      setTotalParcelas(total);
    } else if (
      total === 0 &&
      Object.keys(filter).some(
        (key) => (filter as any)[key] !== "" && (filter as any)[key] !== 0
      )
    ) {
      // Só mostra o alerta se o total de parcelas for zero (não há resultados em nenhuma página)
      setFilteredRecords(fichas);
      setTotalParcelas(0);
      Swal.fire({
        title: "Aviso",
        text: "Nenhuma parcela encontrada com os filtros selecionados.",
        icon: "info",
        allowOutsideClick: false,
      });
    } else {
      // Caso haja parcelas, mas não na página atual
      setFilteredRecords(fichas);
      setTotalParcelas(total);
    }
    setLoading(false);
    setIsRequest(false);
  };

  const handleSearchInput = () => {
    if (searchValue !== "") {
      setIsSearch(true);
    } else {
      handleClearSearchInput();
    }
    getDataByFilter(appliedFilters);
  };

  const handleClearSearchInput = () => {
    setIsSearch(false);
    setSearchValue("");

    const clearFilter = { ...appliedFilters, search: "" };

    setAppliedFilters(clearFilter);

    getDataByFilter(clearFilter);
  };

  const clearFilters = () => {
    setAppliedFilters({});
    setFilteredRecords(financialRecords); // Reseta os registros filtrados
    // Desativa o filtro
  };

  const handleRemoveFilter = async (filterKey: string) => {
    const newFilters = { ...appliedFilters };

    // Remove o filtro especificado
    if (["dataVencimentoInicio", "dataVencimentoFim"].includes(filterKey)) {
      // Remove tanto a dataVencimentoInicio quanto a dataVencimentoFim do objeto newFilters
      delete newFilters.dataVencimentoInicio;
      delete newFilters.dataVencimentoFim;
    } else if (
      ["dataPagamentoInicio", "dataPagamentoFim"].includes(filterKey)
    ) {
      delete newFilters.dataPagamentoInicio;
      delete newFilters.dataPagamentoFim;
    } else {
      delete newFilters[filterKey as keyof FilterFichaFinanceiraDto];
    }
    getDataByFilter(newFilters);
    setAppliedFilters(newFilters);
  };

  const getPDFPaymentBill = async (url: string) => {
    try {
      window.open(`${process.env.REACT_APP_API_URL}pdfs/${url}`, "_blank");
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const createBillOfPay = async (
    fichasFinanceiras: GetFinancialRecordDto[]
  ) => {
    const data = {
      idFichaFinanceira: fichasFinanceiras.map((fichas) => fichas.id),
    };

    try {
      Swal.fire({
        title: "Carregando",
        text: "Carregando boletos...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await FichaFinanceiraService.createBillOfPay(data);
      if (response.success) {
        // Abrir o PDF
        window.open(
          `${process.env.REACT_APP_API_URL}pdfs/${response.data.nameFile}`,
          "_blank"
        );

        // Aguardar 1 segundo antes de deletar (tempo para o navegador abrir o PDF)
        setTimeout(async () => {
          const deleteResponse = await FichaFinanceiraService.deleteFileInPdfs(
            response.data.nameFile
          );

          if (deleteResponse.success) {
            const firstResult = await Swal.fire({
              title: "Sucesso!",
              text: "Os boletos foram carregados com sucesso!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });

            if (firstResult.isConfirmed) {
              if (
                fichasFinanceiras.some(
                  (installment) =>
                    installment.statusImpressao ===
                    StatusImpressaoEnum.A_IMPRIMIR
                )
              ) {
                const result = await Swal.fire({
                  title: "Sucesso!",
                  text: `Deseja trocar o status da impressão para ${StatusImpressaoEnum.IMPRESSO}?`,
                  icon: "info",
                  showCancelButton: true,
                  confirmButtonText: "Sim",
                  cancelButtonText: "Não",
                  allowOutsideClick: false,
                });

                if (result.isConfirmed) {
                  const data: UpdateStatusImpressaoDto = {
                    ids: fichasFinanceiras.map((ficha) => ficha.id),
                    status: StatusImpressaoEnum.IMPRESSO,
                  };
                  await handleUpdateStatusImpressao(data.ids, data.status);
                }
              }
            }
          }
        }, 2000); // tempo em milissegundos
      } else {
        Swal.fire({
          title: "Erro",
          text: "Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
    setSelectedInstallments([]);
    setSelectAllByPage([]);
  };

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
    }
  };

  const handleUpdateStatusImpressao = async (
    ids: number[],
    status: StatusImpressaoEnum
  ) => {
    await FichaFinanceiraService.updateStatusImpressaoMany({
      ids,
      status,
    }).then((response) => {
      if (response.success) {
        Swal.fire({
          title: "Sucesso!",
          text: "Status dos boletos atualizados com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        getDataByFilter(appliedFilters);
      }
    });
  };

  const handleSelectAll = (
    fichasFinanceiras: GetFinancialRecordDto[],
    page: number
  ) => {
    // Check if current page exists in selectAllByPage array
    const pageExists = selectAllByPage.includes(page);

    if (pageExists) {
      setSelectAllByPage(
        selectAllByPage.filter((page) => page !== currentPage)
      );
      setSelectedInstallments((prev) =>
        prev.filter((item) => !fichasFinanceiras.find((f) => f.id === item.id))
      );
    } else {
      setSelectAllByPage([...selectAllByPage, currentPage]);
      for (const ficha of fichasFinanceiras) {
        setSelectedInstallments((prev) => {
          const exists = prev.some((item) => item.id === ficha.id);
          if (exists) {
            return prev;
          } else {
            return [...prev, ficha];
          }
        });
      }
    }
  };

  const gerarReciboParcelaPDF = async (parcelas: GetFinancialRecordDto[]) => {
    try {
      // Exibe loading enquanto processa
      Swal.fire({
        title: "Carregando",
        text: "Gerando recibo...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Primeiro, chama o serviço para criar o recibo e obter o número sequencial
      const fichaFinanceiraIds = parcelas.map((parcela) => parcela.id);

      // Importa o ReciboService no topo do arquivo se ainda não estiver importado
      const reciboResponse = await ReciboService.create({
        fichaFinanceiraIds: fichaFinanceiraIds,
        contribuinteId: parcelas[0].idContribuinte,
      });
      const usuario: string =
        JSON.parse(sessionStorage.getItem("user") || "{}").name || "";
      const dateRange = {
        inicio:
          reciboResponse.length > 0
            ? formatDateToBR(parcelas[0].dataVencimento)
            : "",
        fim:
          reciboResponse.length > 0
            ? formatDateToBR(parcelas[reciboResponse.length - 1].dataVencimento)
            : "",
      };

      const responsavel = parcelas[0]?.contribuinte?.nome || "";
      const cpf = parcelas[0]?.contribuinte?.cpfCin || "";

      // Fecha o loading antes de gerar o PDF
      Swal.close();
      const blob = await pdf(
        <ReciboDoacaoPDF
          dateRange={dateRange}
          responsavel={responsavel}
          recibos={reciboResponse} // Passa o array de recibos
          cpf={cpf}
          usuario={usuario}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url);
    } catch (error) {
      console.error("Erro ao gerar recibo:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o recibo. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const handleManualClearance = async () => {
    const existingCaixaOpen = await caixaService.findCaixaOpen();
    if (!existingCaixaOpen) {
      Swal.fire({
        title: "Erro",
        text: "Nenhum caixa aberto encontrado. Abra o caixa antes de realizar baixas manuais.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }
    if (existingCaixaOpen) {
      const today = new Date();
      const formatToday = new Date(
        `${today.getFullYear()}-${
          (today.getMonth() + 1).toString().length === 1
            ? `0${(today.getMonth() + 1).toString()}`
            : (today.getMonth() + 1).toString()
        }-${
          today.getDate().toString().length === 1
            ? `0${today.getDate().toString()}`
            : today.getDate().toString()
        }T00:00:00Z`
      );

      const caixaDate = new Date(existingCaixaOpen?.dataCaixa);

      if (caixaDate.getTime() < formatToday.getTime()) {
        Swal.fire({
          title: "Erro",
          text: "Caixa atual é antigo. Feche e abra o caixa novamente.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return;
      }
    }
    setShowManualClearanceModal(true);
    setIsOpen(null);
  };

  const ReversalManualClearance = async (ficha: GetFinancialRecordDto) => {
    if (!ficha) {
      Swal.fire({
        title: "Erro",
        text: "Selecione pelo menos uma parcela.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return;
    }

    const { value: formValues } = await Swal.fire({
      title: "Confirmar estorno",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, estornar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      html: `
          <div style="display: flex; flex-direction: column; gap: 10px; text-align: left;">
          <p><strong>Deseja estornar a parcela?</strong></p>
            <p><strong>Titular:</strong> ${ficha.contribuinte?.nome || ""}</p>
            <p><strong>Nosso Número:</strong> ${ficha.nossoNumero}</p>
            <p><strong>Vencimento:</strong> ${formatDateToBR(
              ficha.dataVencimento
            )}</p>
            <p><strong>Valor:</strong> ${formatCurrency(ficha.valorParcela)}</p>
          </div>
        `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          id: ficha.id,
        };
      },
    });

    if (formValues) {
      Swal.fire({
        title: "Carregando",
        text: "Estornando parcela...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      await FichaFinanceiraService.ReversalManualClearance(formValues.id)
        .then(async (response) => {
          Swal.close();
          if (response.success) {
            Swal.fire({
              title: "Sucesso",
              html: `
                <div style="display: flex; flex-direction: column; gap: 10px; text-align: left;">
                <p><strong>${response.message}</strong></p>
                  <p><strong>Titular:</strong> ${
                    ficha.contribuinte?.nome || ""
                  }</p>
                  <p><strong>Nosso Número:</strong> ${ficha.nossoNumero}</p>
                  <p><strong>Vencimento:</strong> ${formatDateToBR(
                    ficha.dataVencimento
                  )}</p>
                  <p><strong>Valor:</strong> ${formatCurrency(
                    ficha.valorParcela
                  )}</p>
                </div>
              `,
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
            setIsOpen(null);
            await getDataByFilter(appliedFilters);
            setSelectedInstallments([]);
            setSelectedRecord(null);
          } else {
            Swal.fire({
              title: "Erro",
              text: response.message,
              icon: "error",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        })
        .catch((error) => {
          Swal.close();
          Swal.fire({
            title: "Erro",
            text: error.message,
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        });
    }
  };

  // Substitua a referência única por um mapa de referências
  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());

  useEffect(() => {
    getDataByFilter(appliedFilters);
  }, [idContribuinte]);

  useEffect(() => {
    if (cancelFutureInstallmentsIds.length > 0) {
      const selectedRecords = financialRecords.filter((record) =>
        cancelFutureInstallmentsIds.includes(record.id)
      );
      setSelectedInstallments(selectedRecords);
      setShowCancelInstallmentsModal(true);
    }
  }, [cancelFutureInstallmentsIds, financialRecords]);

  useEffect(() => {
    const fetchDadosFinanceiros = async () => {
      try {
        const response =
          await dadosFinanceirosService.getDadosFinanceirosByContribuinte(
            idContribuinte
          );
        const dadosAtivo = response.find((dado) => !dado.dataExclusao);
        setDadosFinanceirosAtivo(dadosAtivo);
      } catch (error) {
        console.error("Erro ao buscar dados financeiros:", error);
      }
    };

    fetchDadosFinanceiros();
  }, [idContribuinte]);

  useEffect(() => {
    getDataByFilter(appliedFilters);
  }, [currentPage]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(Math.max(totalPages, 1)); // Garante que a página seja válida
    }
  }, [totalPages]);

  useEffect(() => {
    if (shouldRefreshData) {
      getDataByFilter(appliedFilters).then(() => {
        setShouldRefreshData(false); // Após atualizar, redefinir para evitar chamadas desnecessárias
      });
    }
  }, [shouldRefreshData]);

  useEffect(() => {
    if (selectedSingleInstallment) {
      handleReactivateClearance();
    }
  }, [selectedSingleInstallment]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(fichaFinanceiraVisibleColumns); // Inicializa o estado temporário com as colunas visíveis atuais
    }
  }, [isOpenMenuCollumn, fichaFinanceiraVisibleColumns]);

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      // Se não tiver menu aberto, não faz nada
      if (isOpen === null) return;

      // Verifica se o clique foi dentro do menu atual
      const currentMenuRef = menuRefsMap.current.get(isOpen);
      if (currentMenuRef && !currentMenuRef.contains(event.target as Node)) {
        setIsOpen(null);
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpen !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <MainContainer>
      <div className="page contribuinte">
        {/* <Header  /> */}
        <div className="body taxpayer">
          {loading ? (
            <LoadingOverlay>
              <LoadingGif src={loadSCGif} alt="Carregando..." />
            </LoadingOverlay>
          ) : (
            <>
              <div className="ficha-financeira-title">
                <h1>Ficha Financeira</h1>
                <div className="divider"></div>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSearchInput(); // Quando pressionar Enter, ativa a busca
                }}
              >
                <Label htmlFor="cpf-search" id="form-label">
                  Pesquisar pelo nosso número ou valor:
                </Label>
                <ContainerFilter>
                  <InputComponent
                    type="text"
                    id="search"
                    value={searchValue}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const value = e.target.value.replace(",", ".");
                      // Permite apenas números e , para separação decimal
                      if (/^[0-9]*(,|\.)?[0-9]*$/.test(value)) {
                        handleSearchChange({
                          ...e,
                          target: { ...e.target, value },
                        }); // Chama a função que lida com o valor, se válido
                      }
                    }}
                    placeholder="Busque pelo nosso número ou valor"
                    maxLength={45}
                    color="black"
                    width={399}
                    iconRight={
                      isSearch ? (
                        <IoCloseSharp size={24} color={Colors.inputIcon} />
                      ) : (
                        <IoSearchSharp size={24} color={Colors.inputIcon} />
                      )
                    }
                    onIconRightClick={() => {
                      isSearch ? handleClearSearchInput() : handleSearchInput();
                    }}
                    disabled={isRequest}
                  />
                  <ContainerButtons>
                    <Button
                      schemaButton="full-primary"
                      action={() => setIsOpenMenuCollumn(!isOpenMenuCollumn)}
                      icon={
                        <MdOutlineViewColumn
                          size={20}
                          style={{ marginRight: "8px" }}
                        />
                      }
                    >
                      Colunas
                    </Button>

                    <Dropdown.Menu
                      ref={dropdownMenuRef}
                      show={isOpenMenuCollumn}
                      style={{ marginTop: "50px" }}
                    >
                      <DropdownScroll>
                        {[
                          "Parcela",
                          "Sequencial parcela",
                          "Nosso numero",
                          "Tipo cobranca",
                          "Valor parcela",
                          "Vencimento",
                          "Ajuste",
                          "Valor pago",
                          "Tarifa",
                          "Data pagamento",
                          "Status impressao",
                          "Status remessa",
                          "Status remessa baixa",
                        ].map((column, index, array) => (
                          <React.Fragment key={column}>
                            {!defaultColumns.includes(column) && (
                              <Dropdown.Item
                                eventKey="1"
                                onClick={() => handleColumnToggle(column)}
                                style={{ color: Colors.primary }}
                              >
                                <>
                                  <img
                                    src={
                                      tempVisibleColumns.includes(column)
                                        ? "/images/checkbox-marked.svg"
                                        : "/images/checkbox-blank-outline.svg"
                                    }
                                    alt={
                                      tempVisibleColumns.includes(column)
                                        ? defaultColumns.includes(column)
                                          ? "Bloqueado"
                                          : "Selecionado"
                                        : "Não selecionado"
                                    }
                                    className="checkbox-image"
                                  />
                                  <label>{column}</label>
                                  {array
                                    .filter(
                                      (col) => !defaultColumns.includes(col)
                                    )
                                    .indexOf(column) <
                                    array.filter(
                                      (col) => !defaultColumns.includes(col)
                                    ).length -
                                      1 && <DropdownDivider />}
                                </>
                              </Dropdown.Item>
                            )}
                          </React.Fragment>
                        ))}
                      </DropdownScroll>
                      {JSON.stringify(tempVisibleColumns.sort()) !==
                        JSON.stringify(
                          fichaFinanceiraVisibleColumns.sort()
                        ) && (
                        <Dropdown.Item>
                          <FichaFinanceiraMenuDivider />
                          <Button
                            schemaButton="with-margin"
                            action={handleApplyColumns} // Aplica as mudanças ao clicar
                          >
                            Aplicar
                          </Button>
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                    {editOnly && (
                      <Button
                        schemaButton="full-primary"
                        action={() => setShowCadastroParcela(true)}
                        icon={
                          <IoIosAddCircleOutline
                            size={20}
                            style={{ marginRight: "8px" }}
                          />
                        }
                        disabled={isRequest}
                      >
                        Cadastrar parcela
                      </Button>
                    )}
                    <Button
                      schemaButton="full-primary"
                      action={() => setShowFiltroModal(true)}
                      icon={
                        <IoFilter size={20} style={{ marginRight: "8px" }} />
                      }
                      // disabled={isRequest}
                    >
                      Adicionar filtro
                    </Button>
                  </ContainerButtons>
                </ContainerFilter>

                <ContainerButtons>
                  {editOnly &&
                    selectedInstallments.length > 0 &&
                    selectedInstallments.some(
                      (installment) =>
                        installment.statusParcela === StatusParcelaEnum.ATIVA
                    ) && (
                      <>
                        <Button
                          type="button"
                          schemaButton="out-primary"
                          action={() => {
                            if (selectedInstallments.length <= 0) {
                              Swal.fire({
                                title: "Atenção",
                                text: "Selecione ao menos uma parcela.",
                                icon: "warning",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              });
                            } else {
                              handleManualClearance();
                            }
                          }}
                        >
                          Dar baixa
                        </Button>
                        <Button
                          type="button"
                          schemaButton="out-primary"
                          action={() => {
                            if (selectedInstallments.length <= 0) {
                              Swal.fire({
                                title: "Atenção",
                                text: "Selecione ao menos uma parcela.",
                                icon: "warning",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              });
                            } else {
                              setShowCancelInstallmentsModal(true);
                            }
                          }}
                        >
                          Cancelar
                        </Button>
                      </>
                    )}
                  {selectedInstallments.length > 0 &&
                    selectedInstallments.some(
                      (installment) =>
                        installment.statusParcela ===
                        StatusParcelaEnum.CANCELADA
                    ) && (
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedInstallments.length <= 0) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione ao menos uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            handleReactivateClearance();
                          }
                        }}
                      >
                        Reativar
                      </Button>
                    )}
                  {selectedInstallments.length > 0 &&
                    selectedInstallments.every(
                      (installment) =>
                        installment.statusParcela !==
                          StatusParcelaEnum.CANCELADA &&
                        installment.statusImpressao !==
                          StatusImpressaoEnum.NAO_IMPRIMIR &&
                        installment.statusImpressao !==
                          StatusImpressaoEnum.PENDENTE
                    ) && (
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedInstallments.length <= 0) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione ao menos uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            createBillOfPay(selectedInstallments);
                          }
                        }}
                      >
                        Imprimir
                      </Button>
                    )}
                  {editOnly && selectedInstallments.length > 0 && (
                    <>
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedInstallments.length <= 0) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione ao menos uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            // Evita propagação do evento
                            handleUpdate(
                              selectedInstallments.map((id) => id.id),
                              StatusImpressaoEnum.A_IMPRIMIR
                            );
                            setIsOpen(null);
                          }
                        }}
                      >
                        Trocar Status de Impressão
                      </Button>
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          if (selectedInstallments.length <= 0) {
                            Swal.fire({
                              title: "Atenção",
                              text: "Selecione ao menos uma parcela.",
                              icon: "warning",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          } else {
                            handleUpdateRemessa(
                              selectedInstallments.map((id) => id.id),
                              StatusRemessaEnum.ENVIAR
                            );
                          }
                        }}
                      >
                        Trocar Status de Remessa
                      </Button>
                    </>
                  )}
                  {/* Novo botão para parcelas pagas */}
                  {todasParcelasPagas && (
                    <Button
                      schemaButton="out-primary"
                      action={async () => {
                        if (selectedInstallments.length === 0) {
                          Swal.fire(
                            "Atenção",
                            "Selecione ao menos uma parcela para gerar o recibo.",
                            "warning"
                          );
                          return;
                        }
                        try {
                          await gerarReciboParcelaPDF(selectedInstallments);
                        } catch (error) {
                          Swal.fire("Erro", "Erro ao gerar o recibo.", "error");
                        }
                      }}
                    >
                      Gerar Recibo
                    </Button>
                  )}
                  {selectedInstallments.length === 1 &&
                    selectedInstallments.every(
                      (installment) =>
                        installment.idCaixa !== null &&
                        installment.idCaixa !== undefined &&
                        installment.statusParcela === StatusParcelaEnum.PAGA
                    ) && (
                      <Button
                        type="button"
                        schemaButton="out-primary"
                        action={() => {
                          ReversalManualClearance(selectedInstallments[0]);
                          setIsOpen(null);
                        }}
                      >
                        Estorno baixa
                      </Button>
                    )}
                </ContainerButtons>
              </form>

              {showCadastroParcela && (
                <CadastroParcela
                  onSubmit={handleParcelSubmit}
                  onClose={() => setShowCadastroParcela(false)}
                  idContribuinte={idContribuinte}
                  dadosFinanceiros={dadosFinanceirosAtivo}
                  onParcelaCadastrada={() => getDataByFilter(appliedFilters)}
                  show={showCadastroParcela}
                />
              )}

              {showFiltroModal && (
                <TabelaFiltroModal
                  onClose={() => setShowFiltroModal(false)}
                  onApplyFilters={applyFilters}
                  onClearFilters={clearFilters}
                  initialValues={{
                    ...(appliedFilters as any),
                  }}
                  show={showFiltroModal}
                />
              )}

              {Object.entries(appliedFilters).length > 0 &&
                Object.entries(appliedFilters).some(
                  ([key]) => key !== "search"
                ) && (
                  <AppliedFilters>
                    <i className="fa fa-filter" aria-hidden="true"></i>
                    <p>Filtros aplicados:</p>
                    <FiltersContainer>
                      {Object.entries(appliedFilters).length > 0 ? (
                        Object.entries(appliedFilters).map(([key, value]) => {
                          let formattedValue = value;

                          if (
                            key === "dataPagamentoInicio" &&
                            appliedFilters["dataPagamentoFim"]
                          ) {
                            const dataPagamentoInicio = formatDateToBR(
                              value.split("T")[0]
                            );
                            const dataPagamentoFim = formatDateToBR(
                              appliedFilters["dataPagamentoFim"].split("T")[0]
                            );
                            formattedValue = `${dataPagamentoInicio} - ${dataPagamentoFim}`;
                            return (
                              <FilterItem key="intervaloPagamento">
                                <FilterKey>Intervalo Pagamento: </FilterKey>
                                <FilterValue>{formattedValue}</FilterValue>
                                <FilterRemoveButton
                                  onClick={() => {
                                    handleRemoveFilter("dataPagamentoInicio");
                                    handleRemoveFilter("dataPagamentoFim");
                                  }}
                                >
                                  <img
                                    src="/images/close.svg"
                                    alt="Remove filter"
                                  />
                                </FilterRemoveButton>
                              </FilterItem>
                            );
                          }

                          if (
                            key === "dataVencimentoInicio" &&
                            appliedFilters["dataVencimentoFim"]
                          ) {
                            const dataVencimentoInicio = formatDateToBR(
                              value.split("T")[0]
                            );
                            const dataVencimentoFim = formatDateToBR(
                              appliedFilters["dataVencimentoFim"].split("T")[0]
                            );
                            formattedValue = `${dataVencimentoInicio} - ${dataVencimentoFim}`;
                            return (
                              <FilterItem key="intervalo">
                                <FilterKey>Intervalo de vencimento: </FilterKey>
                                <FilterValue>{formattedValue}</FilterValue>
                                <FilterRemoveButton
                                  onClick={() => {
                                    handleRemoveFilter("dataVencimentoInicio");
                                    handleRemoveFilter("dataVencimentoFim");
                                  }}
                                >
                                  <img
                                    src="/images/close.svg"
                                    alt="Remove filter"
                                  />
                                </FilterRemoveButton>
                              </FilterItem>
                            );
                          }

                          if (key === "search") {
                            return null;
                          }

                          if (
                            key === "dataVencimento" ||
                            key === "dataPagamento" ||
                            key === "intervalo"
                          ) {
                            formattedValue = formatarData(value);
                          }

                          if (
                            key !== "dataVencimentoInicio" &&
                            key !== "dataVencimentoFim" &&
                            key !== "dataPagamentoInicio" &&
                            key !== "dataPagamentoFim"
                          ) {
                            return (
                              <FilterItem key={key}>
                                <FilterKey>{formatFilterName(key)}: </FilterKey>
                                <FilterValue>{formattedValue}</FilterValue>
                                <FilterRemoveButton
                                  onClick={() => handleRemoveFilter(key)}
                                >
                                  <img
                                    src="/images/close.svg"
                                    alt="Remove filter"
                                  />
                                </FilterRemoveButton>
                              </FilterItem>
                            );
                          }

                          return null;
                        })
                      ) : (
                        <p></p>
                      )}
                    </FiltersContainer>
                  </AppliedFilters>
                )}

              <TableContainer>
                {isRequest ? (
                  <LoadingContainer>
                    <LoadingGif src={loadSCGif} alt="Carregando..." />
                  </LoadingContainer>
                ) : (
                  <Table firstColSmall={true} id="tabela-ficha-financeira">
                    <TableHead>
                      <TableRow>
                        <TableHeader>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form>
                              <Form.Check
                                type="checkbox"
                                style={{
                                  transform: "scale(0.85)",
                                  fontSize: "14px",
                                }}
                                id={`default-checkbox-select-all`}
                                checked={selectAllByPage.includes(currentPage)}
                                disabled={isRequest}
                                onChange={(e) => {
                                  handleSelectAll(filteredRecords, currentPage);
                                }}
                              />
                            </Form>
                            <span>Todos</span>
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip id="tooltip-cc">
                                  Selecionar todos os itens da lista
                                </Tooltip>
                              }
                            >
                              <i
                                className="fas fa-info-circle"
                                style={{ cursor: "help" }}
                              ></i>
                            </OverlayTrigger>
                          </div>
                        </TableHeader>
                        {fichaFinanceiraVisibleColumns.includes("Parcela") && (
                          <TableHeader>Parcela</TableHeader>
                        )}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Sequencial parcela"
                        ) && <TableHeader>Sequencial parcela</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Nosso numero"
                        ) && <TableHeader>Nosso N°</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Tipo cobranca"
                        ) && <TableHeader>Tipo cobrança</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Valor parcela"
                        ) && <TableHeader>Valor Parcela</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Vencimento"
                        ) && <TableHeader>Vencimento</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes("Ajuste") && (
                          <TableHeader>Ajuste</TableHeader>
                        )}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Valor pago"
                        ) && <TableHeader>Valor pago</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes("Tarifa") && (
                          <TableHeader>Tarifa</TableHeader>
                        )}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Data pagamento"
                        ) && <TableHeader>Data pagamento</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Status impressao"
                        ) && <TableHeader>Status impressão</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Status remessa"
                        ) && <TableHeader>Status remessa</TableHeader>}
                        {fichaFinanceiraVisibleColumns.includes(
                          "Status remessa baixa"
                        ) && <TableHeader>Status remessa baixa</TableHeader>}
                        <TableHeader>Ações</TableHeader>
                      </TableRow>
                    </TableHead>
                    <tbody>
                      {filteredRecords && filteredRecords.length ? (
                        filteredRecords.map((record, index) => (
                          <TableRow key={index}>
                            <TableData>
                              <Form>
                                <Form.Check
                                  type="checkbox"
                                  style={{
                                    transform: "scale(0.85)",
                                    fontSize: "14px",
                                  }}
                                  id={`default-checkbox-${index}`}
                                  checked={selectedInstallments.some(
                                    (installment) =>
                                      installment.id === record.id
                                  )}
                                  // disabled={
                                  //   record.statusParcela ===
                                  //   StatusParcelaEnum.PAGA
                                  // }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      // Se já existem parcelas selecionadas, verifica se são do mesmo status
                                      if (selectedInstallments.length > 0) {
                                        const currentStatus =
                                          selectedInstallments[0].statusParcela;
                                        if (
                                          record.statusParcela !== currentStatus
                                        ) {
                                          Swal.fire({
                                            title: "Atenção",
                                            text: `Você só pode selecionar parcelas com status "${currentStatus}" no momento. Desmarque as outras parcelas primeiro.`,
                                            icon: "warning",
                                            confirmButtonText: "OK",
                                            allowOutsideClick: false,
                                          });
                                          e.preventDefault();
                                          return;
                                        }
                                      }
                                      setSelectedInstallments([
                                        ...selectedInstallments,
                                        record,
                                      ]);
                                    } else {
                                      setSelectedInstallments((prev) =>
                                        prev.filter(
                                          (item) => item.id !== record.id
                                        )
                                      );
                                      setSelectAllByPage(
                                        selectAllByPage.filter(
                                          (page) => page !== currentPage
                                        )
                                      );
                                    }
                                  }}
                                />
                              </Form>
                            </TableData>
                            {fichaFinanceiraVisibleColumns.includes(
                              "Parcela"
                            ) && <TableData>{record.statusParcela}</TableData>}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Sequencial parcela"
                            ) && (
                              <TableData>{record.sequencialParcela}</TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Nosso numero"
                            ) && <TableData>{record.nossoNumero}</TableData>}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Tipo cobranca"
                            ) && <TableData>{record.tipoCobranca}</TableData>}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Valor parcela"
                            ) && (
                              <TableData>
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(Number(record.valorParcela))}
                              </TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Vencimento"
                            ) && (
                              <TableData>
                                {record.dataVencimento
                                  ? formatarData(
                                      record.dataVencimento as string
                                    )
                                  : "-"}
                              </TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Ajuste"
                            ) && (
                              <TableData>
                                {Number(record.valorAjuste) < 0
                                  ? `- R$ ${new Intl.NumberFormat("pt-BR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(
                                      Math.abs(Number(record.valorAjuste))
                                    )}`
                                  : new Intl.NumberFormat("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    }).format(Number(record.valorAjuste))}
                              </TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Valor pago"
                            ) && (
                              <TableData>
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(Number(record.valorPago))}
                              </TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Tarifa"
                            ) && (
                              <TableData>
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(Number(record.valorTarifa))}
                              </TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Data pagamento"
                            ) && (
                              <TableData>
                                {record.dataPagamento
                                  ? formatarData(record.dataPagamento as string)
                                  : "-"}
                              </TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Status impressao"
                            ) && (
                              <TableData>{record.statusImpressao}</TableData>
                            )}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Status remessa"
                            ) && <TableData>{record.statusRemessa}</TableData>}
                            {fichaFinanceiraVisibleColumns.includes(
                              "Status remessa baixa"
                            ) && (
                              <TableData>
                                {record.statusRemessaBaixa
                                  ? record.statusRemessaBaixa
                                  : "-"}
                              </TableData>
                            )}
                            <TableData
                              style={{
                                position: "relative",
                                overflow: "visible",
                              }}
                            >
                              <ButtonAction
                                onClick={(e) => {
                                  e.stopPropagation(); // Evita que o clique se propague
                                  toggleDropdown(record.id);
                                }}
                                style={{ marginLeft: "auto" }}
                              >
                                {isOpen === record.id ? (
                                  <IoMdClose
                                    cursor={"pointer"}
                                    size={20}
                                    style={{ color: Colors.primary }}
                                  />
                                ) : (
                                  <SlOptionsVertical
                                    cursor={"pointer"}
                                    size={20}
                                    style={{ color: Colors.primary }}
                                  />
                                )}
                              </ButtonAction>
                              <FichaFinanceiraMenuTable
                                ref={(el: HTMLDivElement | null) => {
                                  // Armazena a referência no mapa usando o ID do registro como chave
                                  menuRefsMap.current.set(record.id, el);
                                }}
                                show={isOpen === record.id}
                                align="start"
                                isLastRows={
                                  filteredRecords.length > 0 &&
                                  filteredRecords.indexOf(record) >=
                                    filteredRecords.length - 7
                                }
                              >
                                {editOnly &&
                                  record.statusParcela ===
                                    StatusParcelaEnum.ATIVA && (
                                    <>
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          const installmentsId = [
                                            {
                                              ...record,
                                            } as GetFinancialRecordDto,
                                          ];
                                          setSelectedInstallments(
                                            installmentsId
                                          );
                                          handleManualClearance();
                                        }}
                                      >
                                        Dar baixa
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          setSelectedInstallments([
                                            {
                                              ...record,
                                            } as GetFinancialRecordDto,
                                          ]);
                                          setShowCancelInstallmentsModal(true);
                                          setIsOpen(null);
                                        }}
                                      >
                                        Cancelar
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                    </>
                                  )}

                                {record.statusParcela ===
                                  StatusParcelaEnum.PAGA && (
                                  <>
                                    <FichaFinanceiraMenuItem
                                      onClick={(e) => {
                                        e.stopPropagation(); // Evita propagação do evento
                                        gerarReciboParcelaPDF([record]);
                                      }}
                                    >
                                      Gerar recibo
                                    </FichaFinanceiraMenuItem>
                                  </>
                                )}

                                {editOnly &&
                                  record.statusParcela ===
                                    StatusParcelaEnum.CANCELADA && (
                                    <>
                                      <FichaFinanceiraMenuItem
                                        onClick={async (e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          setSelectedInstallments([
                                            {
                                              ...record,
                                            } as GetFinancialRecordDto,
                                          ]);

                                          setSelectedSingleInstallment({
                                            ...record,
                                          } as GetFinancialRecordDto);

                                          setIsOpen(null);
                                        }}
                                      >
                                        Reativar
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                    </>
                                  )}

                                {record.statusParcela !==
                                  StatusParcelaEnum.CANCELADA &&
                                  record.statusImpressao !==
                                    StatusImpressaoEnum.NAO_IMPRIMIR &&
                                  record.statusImpressao !==
                                    StatusImpressaoEnum.PENDENTE && (
                                    <>
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          createBillOfPay([record]);
                                          setIsOpen(null);
                                          //setSelectedInstallments([record]);
                                        }}
                                      >
                                        Imprimir
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                    </>
                                  )}

                                {record.statusParcela !==
                                  StatusParcelaEnum.CANCELADA &&
                                  record.qrCodePix &&
                                  record.qrCodePix !== "" && (
                                    <>
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          setSelectedRecord(record);
                                          setShowModalQRCode(true);
                                          setIsOpen(null);
                                        }}
                                      >
                                        Detalhes do PIX
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                    </>
                                  )}

                                {editOnly &&
                                  record.statusParcela ===
                                    StatusParcelaEnum.ATIVA && (
                                    <>
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          handleUpdate(
                                            [record.id],
                                            record.statusImpressao
                                          );
                                          setIsOpen(null);
                                        }}
                                      >
                                        Trocar status impressão
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation(); // Evita propagação do evento
                                          handleUpdateRemessa(
                                            [record.id],
                                            record.statusRemessa
                                          );
                                          setIsOpen(null);
                                        }}
                                      >
                                        Trocar status remessa
                                      </FichaFinanceiraMenuItem>
                                      <FichaFinanceiraMenuDivider />
                                    </>
                                  )}

                                <FichaFinanceiraMenuItem
                                  onClick={(e) => {
                                    e.stopPropagation(); // Evita propagação do evento
                                    setSelectedRecord(record);
                                    setShowDetailsModal(true);
                                    setIsOpen(null);
                                  }}
                                >
                                  Ver detalhes
                                </FichaFinanceiraMenuItem>
                                {record.statusParcela ===
                                  StatusParcelaEnum.PAGA &&
                                  record.idCaixa && (
                                    <>
                                      <FichaFinanceiraMenuDivider />
                                      <FichaFinanceiraMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedInstallments([record]);
                                          setSelectedRecord(record);
                                          ReversalManualClearance(record);
                                          setIsOpen(null);
                                        }}
                                      >
                                        Estorno baixa
                                      </FichaFinanceiraMenuItem>
                                    </>
                                  )}
                              </FichaFinanceiraMenuTable>
                            </TableData>
                          </TableRow>
                        ))
                      ) : (
                        <tr>
                          <TableData
                            className="text-center text-muted"
                            colSpan={fichaFinanceiraVisibleColumns.length + 2}
                          >
                            Nenhuma parcela cadastrada.
                          </TableData>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </TableContainer>

              {filteredRecords.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={Math.ceil(totalParcelas / itemsPerPage)}
                  onPageChange={handlePageChange}
                />
              )}

              {selectedRecord && (
                <>
                  <DetailsModal
                    show={showDetailsModal}
                    onClose={() => setShowDetailsModal(false)}
                    record={selectedRecord}
                    setShowQrCodeModal={setShowModalQRCode}
                  />
                  <QrCodeModal
                    show={showModalQRCode}
                    onClose={() => setShowModalQRCode(false)}
                    qrCode={selectedRecord?.qrCodePix}
                  />
                </>
              )}

              {selectedInstallments.length > 0 && (
                <>
                  <ManualClearanceModal
                    show={showManualClearanceModal && editOnly}
                    onClose={() => {
                      setShowManualClearanceModal(false);
                      setSelectedInstallments([]);
                      setSelectAllByPage([]);
                    }}
                    installments={selectedInstallments}
                    onSuccess={() => getDataByFilter(appliedFilters)}
                  />
                  <CancelInstallmentsModal
                    show={showCancelInstallmentsModal && editOnly}
                    onClose={() => {
                      setCancelFutureInstallmentsIds([]);
                      setSelectedInstallments([]);
                      setSelectAllByPage([]);
                      setShowCancelInstallmentsModal(false);
                    }}
                    installments={selectedInstallments}
                    fetchAllParcelas={() => getDataByFilter(appliedFilters)}
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </MainContainer>
  );
};
export default FichaFinanceiraPage;
